<template>
    <div>
        <header class="header z-depth-4">
            <div id="line-top"></div>
            <div class="reservas hide-on-small-only">
                <div class="card z-depth-4">
                    <div class="card-content brown-text hoverable">
                        <span class="card-title"><i class="tiny material-icons">hotel</i>Reservas</span>
                        <p><i class="tiny material-icons">phone</i>(33)3263-3883</p>
                    </div>
                    <div class="card-action">
                        <a href="#/reservas">Click aqui</a>
                    </div>
                </div>
            </div>
            <div class="container valign-wrapper">
                <div class="row" style="margin-bottom: 0 !important;">
                    <div class="col s2">
                        <a href="#!">
                            <img class="" width="100" height="100" src="./img/logo.png" />
                        </a>
                    </div>
                    <div class="col s10 center-align hide-on-small-only titulo-principal">
                        <h4 class="brown-text darken-4">Resplendor Center Hotel</h4>
                    </div>
                </div>
            </div>
            <nav>
                <div class="nav-wrapper container">
                    <a href="#" data-activates="nav-mobile" class="button-collapse"><i class="material-icons">menu</i></a>
                    <ul class="left hide-on-med-and-down">
                        <li class="nav-home"><a href="#/home">Home</a></li>
                        <li class="nav-hotel"><a href="#/hotel">O Hotel</a></li>
                        <li class="nav-acom"><a href="#/acomodacoes/suite-nupcias">Acomodações</a></li>
                        <li class="nav-serv"><a href="#/servicos">Serviços</a></li>
                        <li class="nav-cafe"><a href="#/cafe">Café da Manhã</a></li>
                        <li class="nav-reser"><a href="#/reservas">Reservas</a></li>
                        <li class="nav-resp"><a href="#/resplendor">Resplendor</a></li>
                    </ul>
                    <ul id="nav-mobile" class="side-nav">
                        <li class="nav-home"><a href="#/home">Home</a></li>
                        <li class="nav-hotel"><a href="#/hotel">O Hotel</a></li>
                        <li class="nav-acom"><a href="#/acomodacoes/suite-nupcias">Acomodações</a></li>
                        <li class="nav-serv"><a href="#/servicos">Serviços</a></li>
                        <li class="nav-cafe"><a href="#/cafe">Café da Manhã</a></li>
                        <li class="nav-reser"><a href="#/reservas">Reservas</a></li>
                        <li class="nav-resp"><a href="#/resplendor">Resplendor</a></li>
                    </ul>
                </div>
            </nav>
        </header>
        <main class="z-depth-3">
            <router-view></router-view>
        </main>
        <footer class="page-footer z-depth-3">
            <div class="container" style="height: 100%">
                <div class="row logo_rodape">
                    <div class="col s2 m2 l2">
                        <a href="#!"><img class="responsive-img" width="80" height="80" src="./img/logo.png" /></a>
                    </div>
                    <div class="col s4 m5 l5 text-rodape flow-text">
                        <p class="hide-on-small-only">Av. Olegário Maciel N.364 B</p>
                        <p class="hide-on-small-only">Centro, Resplendor MG </p>
                        <p><i class="tiny material-icons">phone</i>(33)3263-3883</p>

                    </div>
                    <div class="col s2 m1 l1">
                        <a class="brown-text" href="https://www.facebook.com/pages/Resplendor-Center-Hotel/405922639457098?fref=ts" target="_blank"><i class="medium ion-logo-facebook"></i></a>
                    </div>
                    <div class="col s2 m1 l1">
                        <a class="brown-text" href="https://www.instagram.com/resplendorcenterhotel/" target="_blank"><i class="medium ion-logo-instagram"></i></a>
                    </div>
                    <div class="col s2 m3 l3 right">
                        <a href="http://netzachsolutions.com.br" target="_blank">
                            <img class="responsive-img" width="110" height="110" src="./img/SmallLogo.png" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script type="text/javascript">
    export default {
        mounted(){
            $(".button-collapse").sideNav({
                closeOnClick: true
            });
        }
    };
</script>


// WEBPACK FOOTER //
// app.vue?7e55bbfe